"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Section_1 = __importDefault(require("./Section"));
const material_1 = require("@mui/material");
const PageTitle = ({ title }) => {
    const splitTitle = title.split(' ');
    return (react_1.default.createElement(Section_1.default, null,
        react_1.default.createElement(PageTitleContainer, null, splitTitle.map((e, i) => (react_1.default.createElement(material_1.Box, { key: i, style: { fontWeight: i === 0 ? 300 : 600, display: 'inline' } },
            ' ',
            e))))));
};
exports.default = PageTitle;
const PageTitleContainer = (0, styled_components_1.default)('h1') `
  padding: 0;
  color: ${(props) => props.theme.colors.onBg};
  grid-column: span 12;
  font-size: 3.125em;
  font-weight: 400;
  line-height: 1em;
  ${(props) => props.theme.media.lg} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span 12;
  }
`;
